export default "__VITE_ASSET__6afe2d87__"